// extracted by mini-css-extract-plugin
export default {"expertiseStyles":"Expertise_expertiseStyles__k8Glo","images":"Expertise_images__tTSxm"};